import { render, staticRenderFns } from "./PublishingSchedule.vue?vue&type=template&id=4b01e9fe&"
import script from "./PublishingSchedule.vue?vue&type=script&lang=js&"
export * from "./PublishingSchedule.vue?vue&type=script&lang=js&"
import style0 from "./PublishingSchedule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VSkeletonLoader})
